import { Navigate } from 'react-router-dom';
import { useAuth } from '../providers/auth';

const PrivateRoute = ({ element }) => {
    const { isAuthenticated } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" />;  // Điều hướng tới trang login nếu chưa xác thực
    }

    return element;  // Trả về element nếu đã xác thực
};

export default PrivateRoute;
